const apiGetBookInfo = bookId => `/api/books/${bookId}/published`;

const apiGetMyBooks = "/api/books/my_books/"; // get

const apiBookUpload = "/api/books/my_books/"; // post

const apiGetMyBooksInfo = bookId => `/api/books/my_books/${bookId}/`; // get


const apiGetBookStatuses = bookId => `/api/books/my_books/${bookId}/status/`; // get


const apiGetPodCost = bookId => `/api/books/pdf/${bookId}/pod_cost/`;

const apiGetPdfStatus = bookId => `/api/books/pdf/${bookId}/`; // get


const apiDelayedPdfGeneration = bookId => `/api/books/pdf/${bookId}/generation/`; // post

/** Get book meta from api */


const apiGetMeta = bookId => `/api/books/master/meta/${bookId}/`; // get

/** Tags autocomplete api link */


const apiTagsAutocomplete = "/api/books/tags/";
/** Get first level genres */

const apiGetRootGenres = "/api/books/genres/";
/** Genres autocomplete api link */

const apiGenresAutocomplete = "/api/books/genres/";
/** Get genre node */

const apiGetGenreNode = genreId => `/api/books/genres/${genreId}/children/`;
/** Get cover meta from api*/


const apiGetCoverMeta = bookId => `/api/books/cover/${bookId}/`; // get

/** Generation and get covers  */


const apiGenerateCovers = bookId => `/api/books/cover/${bookId}/generation/`;
/** Get cover meta from api*/


const apiBackgroundImages = "/api/books/background_images/";
/** Add proof document for the cover */

const apiPostCoverProofDocument = "/api/books/cover_document/";
/** Remove proof document for cover */

const apiDeleteCoverProofDocument = uuid => `/api/books/cover_document/${uuid}`;
/** Get file link and status from api*/


const apiPutBookFile = bookId => `/api/books/file/${bookId}/`; // put

/** Get formatted fb2 */


const apiGetFormattedFB2 = bookId => `/api/books/master/formatted_fb2/${bookId}/`;
/** Put formatted fb2 */


const apiPutFormattedFB2 = bookId => `/api/books/master/formatted_fb2/${bookId}/`;
/** Get book moderation comment */


const apiGetBookModerationComment = bookId => `/api/books/moderation-comment/${bookId}/`; // get

/** Send book to moderation */


const apiSendBookToModeration = bookId => `/api/books/master/meta/${bookId}/publication/`; // put


function patchUrls(bookId) {
  return {
    meta: `/api/books/master/meta/${bookId}/`,
    license: `/api/books/master/meta/${bookId}/`,
    cover: `/api/books/cover/${bookId}/`,
    coverImage: `/api/books/cover/${bookId}/`,
    file: `/api/books/file/${bookId}/`
  };
}

const apiPatchMasterUrls = (type, bookId) => patchUrls(bookId)[type];

export { apiGetBookInfo, apiGetMyBooks, apiBookUpload, apiGetMyBooksInfo, apiGetBookStatuses, apiGetPodCost, apiGetPdfStatus, apiDelayedPdfGeneration, apiGetMeta, apiTagsAutocomplete, apiGetRootGenres, apiGenresAutocomplete, apiGetGenreNode, apiGetCoverMeta, apiGenerateCovers, apiBackgroundImages, apiPostCoverProofDocument, apiDeleteCoverProofDocument, apiPutBookFile, apiGetFormattedFB2, apiPutFormattedFB2, apiGetBookModerationComment, apiSendBookToModeration, apiPatchMasterUrls };